import { create } from "zustand";
import type { User } from "@shared/core/types";
import { api, ApiError } from "../lib/api";

interface AuthState {
  user: User | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
  setUser: (user: User) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  login: async (email, password) => {
    const u = await api<User>("/api/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
    set({ user: u });
  },
  logout: async () => {
    try {
      await api("/api/auth/logout", { method: "POST" });
    } catch {
      // déjà déconnecté
    }
    set({ user: null });
  },
  refresh: async () => {
    try {
      const u = await api<User>("/api/auth/me");
      set({ user: u, loading: false });
    } catch (e) {
      if (!(e instanceof ApiError) || e.status !== 401) console.error("auth refresh failed", e);
      set({ user: null, loading: false });
    }
  },
  setUser: (user) => set({ user }),
}));
